import './generic-error.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
var GenericError = function GenericError(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? 'Generic error message' : _ref$errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Error"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 offset-md-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "generic-error"
  }, /*#__PURE__*/React.createElement("p", {
    className: "lead"
  }, /*#__PURE__*/React.createElement(T, {
    source: errorMessage
  }))))));
};
export default GenericError;